export default __webpack_public_path__ + "static/media/residence-type-house.57d5e32d.jpg";